
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { PromiserMixin, PromiserType } from 'vuex-modals';
import PersistentModal from '@/components/shared/modals/PersistentModal';
import { SubTechnology } from '@/api/interfaces';
import Autocomplete from '@/components/shared/Autocomplete.vue';
import { repositories } from '@/api/ApiFactory';
import ErrorHandler from '@/components/shared/errorHandler';
import { subTechnologyCreateData } from '@/api/connectivity/subTechnology';
import { ValidationProvider } from 'vee-validate';
@Component({
  components: {
    Autocomplete,
  },
})
export default class AddOrEditSubTechnologyModal extends Mixins<
  PromiserType,
  PersistentModal
>(PromiserMixin, PersistentModal) {
  @Prop({ default: null }) private data!: SubTechnology | null;
  @Prop() private editMode!: boolean;

  public $refs!: {
    obs: InstanceType<typeof ValidationProvider>;
  };

  private loading = {
    submit: false,
  };

  private subTechnology: subTechnologyCreateData = {
    name: '',
    slug: '',
  };

  created() {
    if (this.editMode && this.data != null) {
      this.subTechnology = {
        name: this.data.name,
        slug: this.data.slug,
      };
    }
  }

  mounted() {
    if (this.editMode) {
      this.$nextTick(() => {
        this.$refs.obs.validate();
      });
    }
  }

  private async submitUpdate() {
    this.loading.submit = true;
    try {
      const { data } = await repositories.connectivity.subTechnology.update(
        this.data!.slug,
        this.subTechnology,
      );
      this.ok(data);
    } catch (error) {
      this.$toasted.error(new ErrorHandler({ error, status: true }).toString());
    }
    this.loading.submit = false;
  }

  private async submitCreate() {
    this.loading.submit = true;
    try {
      const { data } = await repositories.connectivity.subTechnology.create(
        this.subTechnology,
      );
      this.ok(data);
    } catch (error) {
      this.$toasted.error(new ErrorHandler({ error, status: true }).toString());
    }
    this.loading.submit = false;
  }

  private submit() {
    return this.editMode ? this.submitUpdate() : this.submitCreate();
  }
}
